<template>
<div class="content starting">
    <div class="login boxLogin">
        <b-row>
            <b-col class="box" v-bind:style="{ backgroundImage: 'url(' + background + ')'}">
                <img :src="logo" v-bind:class="position">
            </b-col>
            <b-col>
                <div class="bylogin" v-if="showView ==='login'">
                    <h4>{{ $t("messages.login.signin") }}</h4>
                    <div class="form-group">
                        <b-form-input type="text" v-bind:placeholder="$t('messages.login.placeholder.email')" v-model="email"></b-form-input>
                    </div>
                    <div class="form-group">
                        <b-form-input type="password" v-bind:placeholder="$t('messages.login.placeholder.password')" v-model="password"></b-form-input>
                    </div>
                    <button class="remember" @click="showView ='remember'">{{ $t("messages.login.forgetPassword") }}</button>
                    <button class="enter" v-on:click="signIn" :disabled="isLoading">{{ $t("messages.login.enter") }}</button>

                    <hr>
                    <p>{{ $t("messages.login.createAccountInfo") }} <b-button size="sm" variant="link" v-on:click="showView ='signup'">{{ $t("messages.login.createAccount") }}</b-button>
                    </p>
                </div>
                <div v-else-if="showView ==='remember'">
                    <h4>{{ $t("messages.login.passwordRecovery") }}</h4>
                    <div class="form-group">
                        <b-form-input type="text" v-bind:placeholder="$t('messages.login.placeholder.email')" v-model="rememberEmail"></b-form-input>
                    </div>
                    <!-- Cancel -->
                    <button class="remember" @click="showView ='login'">{{ $t("messages.cancel") }}</button>
                    <button v-on:click="rememberPassword" :disabled="rememberEmail.length == 0">{{ $t("messages.login.request") }}</button>
                </div>
              
                <sign-up v-else-if="showView ==='signup'" v-bind:company="company" v-bind:actionCodeSettings="actionCodeSettings" v-on:onShowTerms="showTerms" v-on:setLogin="showView ='login'" v-on:logged="onLogged" v-on:onSuccess="onSuccess" v-on:onError="onError" v-on:onLogout="onCancel"></sign-up>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown right>
                    <template slot="button-content">
                        <em> {{ currentLanguage }} </em>
                    </template>
                    <b-dropdown-item v-for="(lang, i) in languages" :key="`Lang${i}`" :value="lang.key" @click="$i18n.locale = lang.code">{{ lang.name }}</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
                 <a :href="null" @click="showTerms" target="_blank" class="footer-link">{{ $t("messages.login.legal") }}</a>
            </b-col>
        </b-row>
    </div>

    <modal name="terms"
        classes="modal-detail"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        width="55%"
        height="95%"
        :clickToClose="false">
        <div class="modal-detail-content" style="overflow:hidden;height:100%;position:relative;">
            <b-btn @click="$modal.hide('terms');" class="closePopup"> <icon name="times-circle"></icon> </b-btn>
            <div class="sign-up" style="height:100%;">
                <!-- AVISO LEGAL Y CONDICIONES GENERALES DE USO -->
                <h4>{{ $t("messages.legalWarning") }}</h4>
                <terms :company="company"></terms>
            </div>
            
        </div>
    </modal>
    <modal name="GDPR"
        classes="modal-detail"
        :pivot-y="0.5"
        :adaptive="true"
        :reset="true"
        width="30%"
        height="550"
        :clickToClose="false">
        <div class="modal-detail-content">
            <!-- <b-btn @click="$modal.hide('GDPR');" class="closePopup"> <icon name="times-circle"></icon> </b-btn> -->
            <gdpr :company="company" v-on:onFinish="onFinish" v-on:onCancel="signOut" v-on:onResize="onResize"></gdpr>
        </div>
    </modal>
       
    <cookie-law theme="dark-lime" v-bind:buttonText="$t('messages.accept')" >
    <div slot="message">
        <!-- This website uses cookies to ensure you get the best experience on our website <router-link to="legal-notes">Click here</router-link> -->
        {{ $t("messages.cookies") }} <b-btn @click="$modal.show('terms');" class="closePopup"> {{ $t('messages.moreinfo') }}</b-btn>
    </div>
    </cookie-law>
</div>
</template>

<script>

const fb = require('../firebaseConfig.js')
import SignUp from './SignUp.vue'
import gdpr from './GDPR.vue'
import { mapState } from 'vuex'
import CookieLaw from 'vue-cookie-law'
import Terms from './Terms.vue'

export default {
    name: 'login',
    components:{
        SignUp,
        CookieLaw,
        gdpr,
        Terms
    },
    computed: {
        currentLanguage: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            return this.languages[index].name;
        },
        ...mapState(['languages', 'actionCodeSettings', 'userProfile'])
    },
    data: function () {
        return {
            email: '',
            sendEmail: '',
            password: '',
            rememberEmail: '',
            showView: 'login',
            unwatch: null,
            isLoading: false
        }
    },
    beforeCreate(){
      let host = window.location.host.toLowerCase()
      switch(host){
        case 'www.da-gen.com':
        case 'da-gen.com':
            this.logo = null
            this.background = require('@/assets/logos/bg/da-gen.jpg')
            this.position='middle',
            this.company = 4;
            this.isHW = true
        break;
        case 'hayward.vistapool.es':
        case 'poolwatch.hayward.fr':
            this.logo = null 
            this.background = require('@/assets/logos/bg/PHOTO-HAYWARD-A4.png')
            this.position='top',
            this.company = 2
            this.isHW = true
        break;
        case 'www.kripsolpool.com':
        case 'kripsolpool.com':
            this.logo = null 
            this.background = require('@/assets/logos/bg/PHOTO-KRIPSOL-A4-1.png')
            this.position='top',
            this.company = 5
            this.isHW = true
        break;
        case 'naturally-salt-poolaccess.de':
        case 'naturally-salt-poolaccess.eu':
        case 'naturally-salt-poolaccess.at':
        case 'naturally-salt-poolaccess.fr':
        case 'naturally-salt-poolaccess.es':
        case 'naturally-salt-poolaccess.com':
        case 'naturally-salt-poolaccess.net':
        case 'www.naturally-salt-poolaccess.de':
        case 'www.naturally-salt-poolaccess.eu':
        case 'www.naturally-salt-poolaccess.at':
        case 'www.naturally-salt-poolaccess.fr':
        case 'www.naturally-salt-poolaccess.es':
        case 'www.naturally-salt-poolaccess.com':
        case 'www.naturally-salt-poolaccess.net':
            this.logo = require('@/assets/logos/naturally.png') 
            this.background = require('@/assets/logos/bg/bg_naturally_salt.jpg')
            this.position='middle'
            this.company = 3
            this.isHW = false
        break;
        case 'app.brilix.com':
            this.logo = require('@/assets/logos/brilix_home.png') 
            this.background = require('@/assets/logos/bg/brilix.jpg')
            this.position='top'
            this.company = 6
            this.isHW = false
            this.title = 'Brilix'
        break;
        case 'compass-salt-water.com':
            this.logo =  require('@/assets/logos/compass.png') 
            this.background = require('@/assets/logos/bg/compass.jpg')
            this.position='top'
            this.company = 7
            this.isHW = false
        break;
        
        default:
            this.logo = require('@/assets/logos/logo.png')
            this.background = require('@/assets/logos/bg/pool_footage.jpg')
            this.position='middle',
            this.company = 1
            this.isHW = true
      }

    },

    mounted() {
        window.addEventListener('keyup', this.onKeyEnter);
        if(this.company== 6){
            window.document.title = this.title || 'Domotic for swimmingpools';
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = '/static/favicon_brillix.ico';
            document.getElementsByTagName('head')[0].appendChild(link);
            this.$i18n.locale = 'en'
        }
    },

    methods: {
        onKeyEnter(event){
            if (event.keyCode === 13) { 
                this.signIn();
            }
        },
        showTerms() {
             this.$modal.show('terms');  
        },
        signIn: function () {
            this.isLoading = true
            this.$snotify.async(this.$t("messages.login.verifyUser"), () => new Promise((resolve, reject) => {
                fb.auth.signInWithEmailAndPassword(this.email, this.password).then((current) => {
                    this.isLoading = false
                    if(current){
                        window.removeEventListener('keyup', this.onKeyEnter)
                        var unwatch  = this.$watch('userProfile', (profile, oldValue) => {
                          
                            if(profile && !this.checkAccess(profile.company)){
                                this.onCancel()
                                reject({
                                    body: this.$t("messages.userNotExists"),
                                    config: {
                                        timeout: 2500,
                                        closeOnClick: true
                                    }
                                })
                            }
                            if(profile && profile.id){
                                resolve({
                                    body: this.$t("messages.login.userValid"),
                                    config: {
                                        timeout: 1500,
                                        closeOnClick: true
                                    }
                                })
                                this.checkGDPR()
                            }else{
                            // this.onError('User not valid'); 
                                reject({
                                    body: this.$t("messages.userNotExists"),
                                    config: {
                                        timeout: 2000,
                                        closeOnClick: true
                                    }
                                })
                            }
                        })
                    }
      
                }).catch( (err) => {
                    this.isLoading = false
                    let message='';
                    switch(err.code){
                        case 'auth/wrong-password': 
                            message = this.$t("messages.userNotValid")
                        break;
                        default:
                            message = this.$t("messages.userNotExists")
                        break;
                    }
                    reject({
                        body: message,
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    })
                });
            }))
        },
        checkAccess: function(company_id){
            if(this.isHW && (company_id==3 || company_id==6 || company_id==7)){
                return false;
            }else if(!this.isHW && (this.company!=company_id)){
                return false;
            }
            return true;
        },
        checkGDPR: function(){
            if (this.userProfile.GDPR === false) {
                this.$modal.show('GDPR');
            }  else {
                if(this.$route.query.from && this.$route.query.from!=''){
                    this.$router.replace(this.$route.query.from);
                }else{
                    this.$router.replace('dashboard') 
                }
            }
        },
       onLogged: function(){
            this.$router.replace('dashboard') 
            this.$store.commit('setUserGDPR')
        },
        onFinish: function(){
            this.$modal.hide('GDPR');
            this.$router.replace('dashboard') 
            this.$store.commit('setUserGDPR')
        },
        onCancel: function(){
            this.$modal.hide('GDPR');
            // this.$store.dispatch('clearAll')
            this.signOut()
        },
        signInByEmail: function () {
            fb.auth.sendSignInLinkToEmail(this.sendEmail, this.actionCodeSettings)
                .then(() => {
                    this.onSuccess(this.$t("messages.login.requestSuccess"));
                    window.localStorage.setItem('emailForSignIn', this.sendEmail);
                })
                .catch( (err) => {
                    this.onError(err.message);
                });
        },
        rememberPassword: function () {
           var actionCodeSettings= {
               url: this.sanitizeUrl('https://'+window.location.host.toLowerCase()),
                handleCodeInApp: true
            }
           
            fb.auth.sendPasswordResetEmail(this.rememberEmail, actionCodeSettings).then( (result) => {
                this.onSuccess(this.$t("messages.login.requestSuccess"));
            }).catch( (err) => {
                this.onError(err.message);
            });
        },
        sanitizeUrl(url){
            return url.replace(/^(https?:\/\/)(www\.)/, '$1');
        },
        onSuccess: function (msg) {
            this.$snotify.success(msg, 'Info', {
                timeout: 3000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
            });
        },
        onError: function(msg) {
            console.log('Error. ' + msg)
            this.$snotify.error(msg, 'Error', {
                timeout: 3000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
            });
        },
        showLegal () {
            this.$modal.show('terms');
        },
        onResize() {
            this.modalClass = 'second'
        },

        signOut(){
            fb.auth.signOut().then(() => {
            this.$store.dispatch('clearData')
            this.$router.push('/login')
        }).catch(err => {
            console.log(err)
        })
        }

    }
}
</script>
<style>
.modal-detail {
    border-radius: 5px;
    background: #F7F7F7;
    box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
  }

  .modal-detail-content {
    padding: 10px;
    height: 530px;
  }

</style>


// WEBPACK FOOTER //
// src/components/Login.vue